import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {withRouter} from "react-router";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CreateStockTransferForm";
import {cancelImportStockTransfer} from "../../../actions/StockTransferApiActions";
import {getAllWarehouses} from "../../../lib/Warehouses";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "originWarehouseId");
  errors = validatePresence(errors, values, "destinationWarehouseId");
  errors = validatePresence(errors, values, "transportType");
  return errors.toJS();
}

// Import creates a transfer directly "in transit" with no origin
// drawdown — used to onboard transfers that are already under way. It reuses the
// Create presentational form; only the mutation differs.
class ImportStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.importStockTransfer(values.toJS())
      .then((response) => {
        if (response.data.importStockTransfer.errors.length <= 0) {
          this.props.cancelImportStockTransfer();
          this.props.router.push(`/stock-transfers/${response.data.importStockTransfer.id}`);
        } else {
          let errors = createValidationErrors(response.data.importStockTransfer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelImportStockTransfer();
  }

  render() {
    return (
      <Form
        warehouses={getAllWarehouses()}
        errors={this.state.errors}
        validate={validateForm}
        submitLabel="Import"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const IMPORT_STOCK_TRANSFER = gql`
  mutation importStockTransfer($data: ImportStockTransferInput!) {
    importStockTransfer(input: $data) {
      id
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(IMPORT_STOCK_TRANSFER, {
    props: ({ mutate }) => ({
      importStockTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelImportStockTransfer})(withRouter(withMutation(ImportStockTransferFormContainer)));
